export default __webpack_public_path__ + "static/pawels-3c484d63a05009b9d01709bdad5067d9.jpg";